function a(o, r) {
  let t = o(), n = /* @__PURE__ */ new Set();
  return { getSnapshot() {
    return t;
  }, subscribe(e) {
    return n.add(e), () => n.delete(e);
  }, dispatch(e, ...s) {
    let i = r[e].call(t, ...s);
    i && (t = i, n.forEach((c) => c()));
  } };
}
export {
  a as createStore
};
